const skills = [
  { icon: 'ri-chat-3-line', title: 'Умение объяснять', desc: 'Переводить сложные знания в понятные действия, которые сотрудник может повторить.' },
  { icon: 'ri-eye-line', title: 'Умение наблюдать', desc: 'Видеть не только ошибку, но и причину, которая к ней привела.' },
  { icon: 'ri-question-line', title: 'Умение задавать вопросы', desc: 'Помогать сотруднику самостоятельно находить решения вместо постоянной выдачи готовых ответов.' },
  { icon: 'ri-feedback-line', title: 'Обратная связь', desc: 'Показывать, что получилось хорошо, что необходимо изменить и как это сделать.' },
  { icon: 'ri-list-check-2', title: 'Постановка развивающих задач', desc: 'Давать сотруднику задачи немного выше текущего уровня компетенций.' },
  { icon: 'ri-time-line', title: 'Терпение и последовательность', desc: 'Не забирать задачу обратно при первой ошибке сотрудника.' },
  { icon: 'ri-dashboard-line', title: 'Контроль прогресса', desc: 'Отслеживать развитие и постепенно повышать уровень самостоятельности.' },
  { icon: 'ri-user-add-line', title: 'Передача ответственности', desc: 'Постепенно уменьшать зависимость сотрудника от наставника.' },
];

export default function MentorSkills() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Какие навыки нужны наставнику
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Наставничество — это не только «уметь обучать». Это набор конкретных компетенций, которые помогают развивать сотрудника, а не делать работу за него
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {skills.map((s) => (
            <div key={s.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}